<div class="chip-container">
    <mat-chip-list class="chip-list-scroll">
        <mat-chip #chips *ngFor="let item of list" [routerLink]="[ item.url ]" class="outline-chip" [ngClass]="{'is-active': item.isActive}">
            <p class="chip-label">{{item.label}}</p>
        </mat-chip>
    </mat-chip-list>
</div>